<template>
  <div>
    <v-card-title>
      <v-row>
        <v-col cols="3">
          <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
        </v-col>
        <v-checkbox :label="$t('delegation.form.bookingAndInvoices.showAllBookingTypes')" v-model="showAll" class="mx-5" />
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="filteredBookings"
      :search="search"
      :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
      :items-per-page="5"
    >
      <template #item="props">
        <tr>
          <td class="">{{ formatDateView(props.item.creation_date) }}</td>
          <td>
            {{ props.item.name }}

            <v-chip label outlined small style="color: #FFE3F3; background-color: #ff99d0 !important;" v-if="props.item.is_cancelled === 1"
              >{{ $t("booking.canceled") }}
            </v-chip>
            <assigned-delegations-chip :delegations="props.item.delegations" />
          </td>
          <td>{{ props.item.client_name }}</td>
          <td>{{ props.item.client_surname }}</td>
          <td>{{ props.item.reservation_number }} {{ props.item.ticket_number }}</td>
          <td class="datatable-total-amount">
            <template v-if="props.item.invoice_gross_value !== null">{{ props.item.invoice_gross_value }} {{ props.item.invoice_currency }}</template>
            <template v-else-if="props.item.total_amount !== null">{{ props.item.total_amount }} PLN</template>
          </td>
          <td class="text-center text-no-wrap">
            <slot name="action" v-bind:booking="props.item">
              <v-tooltip bottom>
                {{ $t("global.downloadFile") }}
                <template #activator="{on}">
                  <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadAttachment(props.item.id)" class="mx-0" icon v-on="on">
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </slot>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import formatDateView from "../../repository/fotmatDateView";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import AssignedDelegationsChip from "./AssignedDelegationsChip";
import downloadFile from "../../repository/downloadFile";

export default {
  name: "BookingGeneralDataTable",
  components: { AssignedDelegationsChip },
  data: () => ({
    search: "",
    bookings: [],
    showAll: false
  }),
  computed: {
    filteredBookings() {
      if (this.showAll) return this.bookings;
      return this.bookings.filter(v => v.is_other);
    },
    invoices: function() {
      return this.$store.getters["Booking/bookingList"];
    },
    headers() {
      return [
        { text: this.$t("booking.dateShort"), value: "creation_date" },
        { text: this.$t("booking.other.serviceName"), value: "name" },
        { text: this.$t("booking.other.client.name"), value: "client_name" },
        {
          text: this.$t("booking.other.client.surname"),
          value: "client_surname"
        },
        { text: this.$t("booking.numberShort"), value: "reservation_number" },
        { text: this.$t("booking.price"), value: "total_amount" },
        { text: "", value: "actions", sortable: false }
      ];
    }
  },
  methods: {
    viewBooking: function(booking) {
      this.$store.dispatch("Booking/loadBookingDetails", booking);
    },
    formatDateView: formatDateView,
    filterOverAllProperty: filterOverAllProperty,
    downloadAttachment(id) {
      downloadFile("booking/get-booking-file?bookingId=" + id);
    }
  },
  created() {
    this.axios.get("booking/get-general").then(resp => {
      this.bookings = resp.data;
    });
  }
};
</script>

<style scoped></style>
